import { request } from '@/shared/api/request'

export const getWorklogFunc = (params) => {
	return request({ url: `dict/getWorklogFunc`, method: 'GET', params })
}
